import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getCurrentYear } from '../../utils/time'
import OELogoAssetDark from '../../static/images/logos/oe_logo_dark_bg.svg'
import OELogoAssetLite from '../../static/images/logos/oe_logo_lite_bg.svg'

const CopyrightOEContainer = styled.div`
  color: ${props => (props.liteBG ? '#000000' : '#ffffff')};
  font-size: 15px;
  font-weight: 300;
  line-height: 18px;
  text-align: center;
  margin: 57px 0 35px;
`

const OELogo = styled.div`
  display: inline-block;
  background: ${props =>
      props.liteBG ? `url(${OELogoAssetLite})` : `url(${OELogoAssetDark})`}
    no-repeat;
  height: 37px;
  width: 246px;
  margin-bottom: 20px;
  cursor: pointer;
`

const CopyrightOE = props => (
  <CopyrightOEContainer {...props}>
    <OELogo
      {...props}
      onClick={() => window.open('https://www.opportunityeducation.org/')}
    />
    <div>
      {`© 2012-${getCurrentYear()} Opportunity Education Foundation, Inc.`}
    </div>
    <div>Quest Forward Learning™ | All rights reserved.</div>
  </CopyrightOEContainer>
)

CopyrightOE.propTypes = {
  liteBG: PropTypes.bool
}

export default CopyrightOE



// WEBPACK FOOTER //
// ./src/components/auth/CopyrightOE.js